<template>
  <div>
    <!-- NAVBAR -->
    <my-navbar :controller="controller"/>

    <!-- HEADER -->
    <div class="header bg-gradient-dark pb-8 pt-5 pt-md-8">
      <div class="container-fluid">
        <div class="header-body">
          <div class="row">
            <!-- CONTENIDO HEADER -->
            <div class="col-lg-7 col-md-10">
              <h1 class="display-3 text-white">Cargar excel</h1>
              <p class="text-white mt-0 mb-5">Leads a cargar</p>
            </div>
          </div>
        </div>

      <div class="row">
        <div class="col-sm-12">
          <div class="card card-body">
            <my-spinner :loading="filters.loading"/>
            <div class="row">
              <div class="col-sm-3">
                <div class="form-group mb-0">
                  <select class="form-control form-control-alternative" v-model="filters.selected.category">
                    <option value="">Selecciona la categoría</option>
                    <option v-for="s in filters.categorys" :value="s.value" :key="s.value">{{s.caption}}</option>
                  </select>
                </div>
              </div>
              <div class="col-sm-3">
                <div class="form-group mb-0">
                 <input type="file" accept=".xls,.xlsx" class="form-control form-control-alternative" @change="setFile($event)"/>
                </div>
              </div>
              <div class="col-sm-2">
                <div class="form-group mb-0">
                  <button class="btn btn-success" @click="setInfo()" :disabled="_disabledBtn" >CARGAR ARCHIVO</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      </div>
    </div>

    <!-- CONTENT -->
    <div class="container-fluid mt--7" v-if="filters.result.data">
           
            <div class="card">
                 <div class="card-header payment-title">
                <p class="text-muted">Resultados de la carga</p>
            </div>
                <div class="card-header" v-for="(json, index) in filters.result.data.errores" :key="'card_index_errors_' + index">
                    <div class="media">
                        <div class="media-body">
                            <h4 class="media-header mt-0 my-1">
                                <span class="text-muted" style="font-size: 11px;">Nombre: {{json.nombre}} / <strong>{{json.telefono}}</strong></span><br>
                                {{json.email}}
                            </h4>
                            <span class="badge badge-pill badge-danger" style="font-size:9px">
                              {{json.mensajes.join(' / ')}}
                            </span>
                            <br><br>
                        </div>
                    </div>
                    <div class="card">
                        <div class="table-responsive">
                            <table class="table align-items-center table-flush">
                                <thead class="thead-light">
                                    <tr>
                                        <template v-for="(field, data, data_index) in json">
                                            <th v-if="hideCell(data_index)" :key="'tbl_index_th_errors_' + data">{{data}}</th>
                                        </template>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <template v-for="(field, data, data_index) in json">
                                            <td v-if="hideCell(data_index)" :key="'tbl_index_td_errors_' + data">{{field}}</td>
                                        </template>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div class="card-header" v-for="(json, index) in filters.result.data.exitos" :key="'card_index_success_' + index">
                    <div class="media">
                        <div class="media-body">
                            <h4 class="media-header mt-0 my-1">
                                <span class="text-muted" style="font-size: 11px;">Nombre: {{json.nombre}} / <strong>{{json.telefono}}</strong></span><br>
                                {{json.email}}
                            </h4>
                            <span class="badge badge-pill badge-success" style="font-size:9px">
                              {{json.mensajes.join(' / ')}}
                            </span>
                            <br><br>
                        </div>
                    </div>
                    <div class="card">
                        <div class="table-responsive">
                            <table class="table align-items-center table-flush">
                                <thead class="thead-light">
                                    <tr>
                                        <template v-for="(field, data, data_index) in json">
                                            <th v-if="hideCell(data_index)" :key="'tbl_index_th_success_' + data">{{data}}</th>
                                        </template>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <template v-for="(field, data, data_index) in json">
                                            <td v-if="hideCell(data_index)" :key="'tbl_index_td_success_' + data">{{field}}</td>
                                        </template>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
    </div>
    
  </div>
</template>
<script>
import Auth from '@/helpers/middleware'
import sysMsgs from '@/helpers/system.message'
import GlobalServices from "@/services/globals.services";
import LeadsServices from "@/services/leads.services";
import _ from 'underscore';
import { UploadFile } from '@/views/marketing/leads/models/upload.model';

export default {
  name: "leadsUpload",
  data() {
    return {
      actions: Auth.getActions(this.$route.name),
      controller: {
        title: "Marketing",
        mainRouter: "/marketing/leads/upload"
      },
      filters:{
        categorys: GlobalServices.marketing.filters.categorys(),
        selected:{
          category:"",
          file: null
        },
        result: {},
        loading: false
      },
      messages:{
        danger:"Error al cargar el lead",
        warning:"¡Advertencia! se actualizarán todos los registros asociados a la lista premium"
      }
    };
  },
  computed: {
    _disabledBtn(){
        let validate = 0;
        _.each(this.filters.selected, (value, field)=>{
            validate = value == null || value.toString().trim().length == 0 || value == 0 ? validate + 1 : validate;
        });
        return validate > 0 ? true : false;
    }
  },
  methods: {
    setFile(event) {
        this.filters.selected.file = event.target.files[0]
    },
    hideCell(index){
      return !_.contains([0,1,2,9,10,11], index)  
    },
    setInfo(evt){
      sysMsgs.getConfirm("¿Desea carga el excel?", "").then(result => {
          if (result.value) {
            this.filters.loading = true;      
            this.filters.result = {};
            let post = new UploadFile(this.filters.selected.category, this.filters.selected.file);

            LeadsServices.upload.file(post).then(response => { 
              this.filters.loading = false;
              this.filters.result = response.data;
            }).catch(error => {
              sysMsgs.getResponseMessage(error.response);
              console.log(error.response.data);
              this.filters.loading = false;
            }); 
          }
        })
    }
  }
};
</script>

<style scoped>
.btn-select {
  color: #ddd;
  background-color: #ffffff;
  border: 1px solid #ddd;
  border-radius: 5px;
  padding: 5px 10px;
}
.btn-select.active {
    color: #fff;
    background-color: #2dce89 ;
    border: 1px solid #2dce89;

}
.loading-overlay{
  left: 0;
  top: 0;
}

.opacity-01{
    opacity: 0.1;
}
</style>
